import Yup from '../../i18n/yup';


export const FormSchema = Yup.object().shape({
  username: Yup.string().min(8).required(),
  password: Yup.string().max(30).required(),
  age: Yup.number().min(18)
});

export const formsInputsData = [
  {
    id: 'username',
    title: 'LOGIN.LOGIN_PLACEHOLDER',
    type: 'text',
    iconName: 'user',
  },
  {
    id: 'password',
    title: 'LOGIN.PASSWORD',
    type: 'password',
    iconName: 'lock',
  },
  {
    id: 'remember',
    title: 'LOGIN.REMEMBER',
    type: 'checkbox'
  }
];

export const initialValues = {
  username: '',
  password: '',
};
